import React, { Component as BaseComponent } from 'react';
import { readPointerCoordinates } from '../utilities/utilities';

export const cubieEdgeLength = 50;
export const cubeFaceNames = ['front', 'back', 'top', 'bottom', 'left', 'right'];
export const faceOffsetByName = {
    left: [-cubieEdgeLength, 0, 0],
    right: [cubieEdgeLength, 0, 0],
    front: [0, 0, cubieEdgeLength],
    back: [0, 0, -cubieEdgeLength],
    top: [0, -cubieEdgeLength, 0],
    bottom: [0, cubieEdgeLength, 0]
};

class RubikCubie extends BaseComponent {

    constructor(componentProperties) {
        super(componentProperties);

        // Official Rubik's Cube Pantone color codes.
        const startingStickerColors = {};
        startingStickerColors.top = this.props.positionOffset[1] === -cubieEdgeLength ? '#FFFFFF' : '';
        startingStickerColors.bottom = this.props.positionOffset[1] === cubieEdgeLength ? '#FFD700' : '';
        startingStickerColors.left = this.props.positionOffset[0] === -cubieEdgeLength ? '#BA0C2F' : '';
        startingStickerColors.right = this.props.positionOffset[0] === cubieEdgeLength ? '#FE5000' : '';
        startingStickerColors.front = this.props.positionOffset[2] === cubieEdgeLength ? '#009A44' : '';
        startingStickerColors.back = this.props.positionOffset[2] === -cubieEdgeLength ? '#003DA5' : '';

        this.isLayerTurnDisabled = false;
        if (Math.abs(this.props.positionOffset[0]) +
            Math.abs(this.props.positionOffset[1]) +
            Math.abs(this.props.positionOffset[2]) === cubieEdgeLength) {
            this.isLayerTurnDisabled = true;
        }

        this.state = {
            isStickerPressActive: false,
            stickerColorsByFace: startingStickerColors
        };

        this.handleStickerPress = this.handleStickerPress.bind(this);
    }

    componentDidMount() {
        this.cubieElement.addEventListener('mouseup', this.handlePointerRelease);
        this.cubieElement.addEventListener('touchend', this.handlePointerRelease);
        this.cubieElement.addEventListener('touchcancel', this.handlePointerRelease);
    }

    componentWillUnmount() {
        this.cubieElement.removeEventListener('mouseup', this.handlePointerRelease);
        this.cubieElement.removeEventListener('touchend', this.handlePointerRelease);
        this.cubieElement.removeEventListener('touchcancel', this.handlePointerRelease);
    }

    buildCubieTransformStyle() {
        return this.props.positionOffset ? {
            transform: `translate3d(${this.props.positionOffset[0]}px,${this.props.positionOffset[1]}px,${this.props.positionOffset[2]}px)
         rotate3d(${this.props.axisAngleOrientation[0]},${this.props.axisAngleOrientation[1]},${this.props.axisAngleOrientation[2]},${this.props.axisAngleOrientation[3]}deg)`
        } : {};
    }

    handleStickerPress(pointerEvent, faceName) {
        if (this.isLayerTurnDisabled) {
            return true;
        }

        pointerEvent.stopPropagation();
        const pointerCoordinates = readPointerCoordinates(pointerEvent);
        this.props.beginLayerTurn(
            { x: pointerCoordinates.clientX, y: pointerCoordinates.clientY },
            faceName
        );
        return false;
    }

    handlePointerRelease() {
        return undefined;
    }

    render() {
        return (
            <div ref={cubieNode => this.cubieElement = cubieNode}
                className="cube" style={this.buildCubieTransformStyle()}>
                {cubeFaceNames.map((faceName, faceOrdinal) => {
                    return <div key={faceOrdinal}
                        onMouseDown={(mouseEvent) => this.handleStickerPress(mouseEvent, faceName)}
                        onTouchStart={(touchEvent) => this.handleStickerPress(touchEvent, faceName)}
                        className={'face ' + faceName}
                        style={{ 'backgroundColor': this.state.stickerColorsByFace[faceName] }}></div>;
                })}
            </div>
        );
    }
}

export default RubikCubie;
